import type { Category } from "./types";

export const CATEGORIES: Category[] = [
  {
    key: "juzu",
    name: "剧组内幕",
    source: "剧组工作人员",
    slogan: "片场的灯，照不亮的地方",
    desc: "副导演、场务、收音、灯光师……那些蹲在大夜戏里、端过几百份盒饭的人，告诉你真实的拍摄现场到底什么样。",
    icon: "ri-clapperboard-line",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20set%20backstage%20behind%20the%20scenes%20with%20lighting%20rigs%20and%20camera%20crane%20silhouettes%2C%20warm%20amber%20and%20cream%20tones%2C%20editorial%20documentary%20photography%20with%20moody%20atmosphere%2C%20authentic%20film%20crew%20working%20in%20motion%2C%20subtle%20grainy%20film%20texture%2C%20no%20faces%20clearly%20visible&width=800&height=1000&seq=cat-juzu&orientation=portrait",
  },
  {
    key: "jingji",
    name: "经纪人手记",
    source: "经纪人爆料",
    slogan: "电话那头，才是真正的江湖",
    desc: "试镜、通告、续约、踩雷……一线经纪人的日程表上写满人情与算计。我们请他们把私下吐槽，换一种体面讲出来。",
    icon: "ri-phone-line",
    image:
      "https://readdy.ai/api/search-image?query=Backstage%20management%20corridor%20with%20warm%20light%20spilling%20from%20dressing%20rooms%2C%20a%20manager%20figure%20holding%20clipboard%20and%20phone%20in%20silhouette%2C%20candid%20editorial%20reportage%20style%2C%20amber%20and%20cream%20palette%2C%20soft%20shadows%2C%20documentary%20mood%2C%20faces%20not%20clearly%20visible&width=800&height=1000&seq=cat-jingji&orientation=portrait",
  },
  {
    key: "yenei",
    name: "业内观察",
    source: "业内制片与平台",
    slogan: "档期与数据，比传闻更诚实",
    desc: "制片人、平台责编、商务与选角副导，用排片表、报价单和收视曲线，解释娱乐圈里那些你看不懂的冷热。",
    icon: "ri-line-chart-line",
    image:
      "https://readdy.ai/api/search-image?query=Red%20carpet%20event%20corridor%20with%20warm%20spotlights%20and%20cream%20backdrop%2C%20empty%20glamorous%20walkway%20with%20photographer%20silhouettes%2C%20editorial%20fashion%20magazine%20photography%2C%20warm%20golden%20and%20paper%20tones%2C%20elegant%20cinematic%20composition%2C%20no%20celebrity%20faces&width=800&height=1000&seq=cat-yenei&orientation=portrait",
  },
  {
    key: "zhiqing",
    name: "知情者密档",
    source: "圈内知情者",
    slogan: "散场之后，才有人敢开口",
    desc: "应酬桌上的几句真话、通告单里的一行备注。匿名的知情者，把那些没法实名说出口的圈内细节，留在这一档里。",
    icon: "ri-lock-2-line",
    image:
      "https://readdy.ai/api/search-image?query=Theatrical%20stage%20curtain%20and%20wing%20area%20with%20warm%20fairy%20lights%20and%20whispered%20conversations%2C%20dramatic%20warm%20backlight%2C%20editorial%20cinematic%20mood%2C%20warm%20amber%20highlights%20against%20cream%20shadows%2C%20intimate%20secret%20atmosphere%2C%20figures%20obscured&width=800&height=1000&seq=cat-zhiqing&orientation=portrait",
  },
];

export const getCategory = (key: string) =>
  CATEGORIES.find((c) => c.key === key);